module.exports = fox._r("images/bg/models_polyline_2.png", __webpack_public_path__ + "images/bg/models_polyline_2.png");


//////////////////
// WEBPACK FOOTER
// ./images/bg/models_polyline_2.png
// module id = 159
// module chunks = 5